import React from "react";
import { connect } from "react-redux";
import { actions, signinActions } from "../../../actions";
import * as socialControlsActions from "../../../actions/socialControlsActions";
import EpisodesDropdown from "../../design/EpisodesDropdown";
import EpisodeMediaObj from "../../design/EpisodesDropdown/EpisodeMediaObj";
import { episodePath } from "../helpers";

class EpisodesControls extends React.Component {
  toggleDropdown = () =>
    this.props.dropdownOpened
      ? this.props.dropdownClose()
      : !this.props.signInModalOpened && this.props.dropdownOpen();

  render = () => (
    <EpisodesDropdown
      onClick={this.toggleDropdown}
      opened={this.props.dropdownOpened}
      {...this.props}
    >
      {this.props.episodes.map((episode, index) => (
        <EpisodeMediaObj
          episode={episode}
          texts={this.props.texts}
          path={episodePath(this.props.storySlug, episode.slug)}
          disableThumb={this.props.story.publication_type === 'novel'}
          key={"episode_" + index}
        />
      ))}
    </EpisodesDropdown>
  );
}

const mapState = (state, ownProps) => ({
  currentEpisode: state.currentEpisode,
  story: state.story,
  dropdownOpened: state.episodes_controls_open,
  episodes: state.episodes,
  readerLabel: I18n.t("components.webreader_episodes_controls.reader"),
  storyUrl: state.signin.modalOpened
    ? EMPTY_HREF
    : LanguageManager.langPath("stories/" + state.story.slug),
  storyTitle: state.story.title,
  storySlug: state.story.slug,
  episodeTitle: state.currentEpisode.title,
  signInModalOpened: state.signin.modalOpened,
  texts: {
    unlockedText: I18n.t("common.paid"),
    freeText: I18n.t("common.free")
  }
});

const mapDispatch = (dispatch, ownProps) => ({
  dropdownClose: () => dispatch(actions.episodesControlsSetClosed()),
  dropdownOpen: () => {
    dispatch(socialControlsActions.closeDrawer());
    dispatch(socialControlsActions.closeSocialDropdown());
    dispatch(signinActions.closeLanguageMenu());
    dispatch(signinActions.closeUserMenu());
    dispatch(actions.episodesControlsSetOpen());
  }
});

export default connect(mapState, mapDispatch)(EpisodesControls);
